export const chapters = [
  {
    id: 7,
    part: 1,
    englishTitle: "One Month",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    content: `Content for What Won't Die...`,
    available: false
  }
];
